module.exports = __webpack_public_path__ + "static/media/regular_paper_straw_black2.c1433655.png";